// extracted by mini-css-extract-plugin
export default {"volunteerContainer":"Volunteer_volunteerContainer__yxHto","volunteerWrapper":"Volunteer_volunteerWrapper__-53jS"};